import { IconComponent } from 'models/icons';

/**
 * This file was auto-generated using svgr
 *
 * Source file: assets/icons/components.svg
 */
const IconComponents: IconComponent = ({
  size = 24,
  color = 'white',
  className,
  svgElementProps: props = {},
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    color={color}
    className={className}
    {...props}
  >
    <path
      d="M23.25 0H.75a.751.751 0 00-.693.462A.751.751 0 000 .75v6a.75.75 0 00.75.75h22.5a.781.781 0 00.75-.75v-6a.775.775 0 00-.75-.75zM.75 6.74V.743H16.5V6.74H.75zm22.5-.011l-.014.014H17.25V.742h5.985l.014.014V6.73z"
      fill="currentColor"
    />
    <path
      d="M14.25 3.375H2.624a.372.372 0 00-.374.375.376.376 0 00.374.375H14.25a.377.377 0 00.375-.375.374.374 0 00-.11-.266.374.374 0 00-.265-.109zM21.487 3.11l-1.236 1.234-1.235-1.234a.374.374 0 00-.529.529l1.5 1.5a.375.375 0 00.529 0l1.5-1.5a.377.377 0 00-.02-.51.375.375 0 00-.509-.02zM23.25 8.25H.75a.751.751 0 00-.693.462A.751.751 0 000 9v6a.75.75 0 00.75.75h22.5A.781.781 0 0024 15V9a.775.775 0 00-.75-.75zM.75 14.99V8.993H16.5v5.999H.75zm22.5-.011l-.014.014H17.25V8.992h5.985l.014.014v5.973z"
      fill="currentColor"
    />
    <path
      d="M14.25 11.635H2.624a.374.374 0 00-.374.375.376.376 0 00.374.375H14.25a.376.376 0 000-.75zM21.487 11.36l-1.236 1.234-1.235-1.234a.375.375 0 00-.529.529l1.5 1.5a.375.375 0 00.529 0l1.5-1.5a.378.378 0 00-.02-.51.375.375 0 00-.509-.02zM23.25 16.5H.75a.753.753 0 00-.693.462.751.751 0 00-.057.288v6a.75.75 0 00.75.75h22.5a.777.777 0 00.75-.75v-6a.775.775 0 00-.75-.75zM.75 23.24v-5.998H16.5v5.999H.75zm22.5-.011l-.014.014H17.25v-6.001h5.985l.014.014v5.973z"
      fill="currentColor"
    />
    <path
      d="M14.25 19.875H2.624a.372.372 0 00-.374.374.376.376 0 00.374.376H14.25a.375.375 0 000-.75zM21.487 19.612l-1.236 1.232-1.235-1.232a.374.374 0 00-.529.528l1.5 1.5a.375.375 0 00.529 0l1.5-1.5a.378.378 0 00.05-.414.371.371 0 00-.092-.114.368.368 0 00-.487 0z"
      fill="currentColor"
    />
  </svg>
);

export default IconComponents;
